// Зашиваем переменные окружения в код при сборке, чтобы env переменные
// были и в SSR и в CSR. Если использовать process.env, в CSR он не доступен
const env = build.process.env;

export const environment = {
  production: env.SDVOR_SPA_ENVIRONMENT === 'production',
  environment: env.SDVOR_SPA_ENVIRONMENT,
  appBaseHref: env.SDVOR_SPA_APP_BASE_HREF,
  smarteditBaseHref: env.SDVOR_SPA_SMARTEDIT_BASE_HREF,
  apiBaseUrlSsr: env.SDVOR_SPA_API_BASE_URL ?? env.SDVOR_SPA_API_BASE_URL_SSR,
  apiBaseUrlCsr: env.SDVOR_SPA_API_BASE_URL ?? env.SDVOR_SPA_API_BASE_URL_CSR,
  strapiBaseUrlSsr: env.SDVOR_SPA_STRAPI_BASE_URL ?? env.SDVOR_SPA_API_BASE_URL_SSR,
  strapiBaseUrlCsr: env.SDVOR_SPA_STRAPI_BASE_URL ?? env.SDVOR_SPA_API_BASE_URL_CSR,
  sentryDsn: env.SDVOR_SPA_SENTRY_DSN,
  sentryRelease: env.SDVOR_SPA_SENTRY_RELEASE,
  smartCaptchaBypassToken: env.SDVOR_SPA_SMARTCAPTCHA_BYPASS_TOKEN,
  yandexMapsApiKey: env.SDVOR_SPA_YANDEX_MAPS_API_KEY,
  anyQueryApiKey: env.SDVOR_SPA_ANY_QUERY_API_KEY,
  yandexMetrikaApiKey: env.SDVOR_SPA_YANDEX_METRIKA_API_KEY,
  daDataApiKey: env.SDVOR_SPA_DA_DATA_API_KEY,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
